export default __webpack_public_path__ + "static/media/blog4.79eeb9b7.png";